module.exports = __webpack_public_path__ + "static/step2-be841476b89afb01dd7376e7ef0e62a5.png";